<template>
  <div
    class="splash-screen"
    :class="{ 'is-leaving': isLeaving }"
    @click="startClose"
  >
    <!-- 3분할 패널 (불투명, 위로 올라가며 사라짐) -->
    <div class="split-panel panel-left" :class="{ 'slide-up': isLeaving }"></div>
    <div class="split-panel panel-center" :class="{ 'slide-up': isLeaving }"></div>
    <div class="split-panel panel-right" :class="{ 'slide-up': isLeaving }"></div>

    <!-- 워터마크 심볼 -->
    <img src="@/assets/logo/logo_symbol.png" alt="" class="splash-watermark" />

    <!-- 장식 라인 -->
    <div class="deco-lines">
      <div class="deco-line line-top"></div>
      <div class="deco-line line-bottom"></div>
    </div>

    <!-- 콘텐츠 -->
    <div class="splash-content" :class="{ 'fade-out': isLeaving }">
      <!-- 서브 타이틀 -->
      <p class="sub-title">프리미엄 라이프의 새로운 기준</p>

      <!-- 메인 타이틀 -->
      <h1 class="main-title">
        <span class="title-brand">테크노</span>
        <span class="title-central">레이원시티</span>
      </h1>

      <!-- 구분선 -->
      <div class="divider"></div>

      <!-- 슬로건 -->
      <p class="slogan">TECHNO RAYONE CITY</p>
    </div>

    <!-- 프로그레스 -->
    <div class="progress-container" :class="{ 'fade-out': isLeaving }">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplashScreen',
  data() {
    return {
      isLeaving: false
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden'

    this.autoCloseTimer = setTimeout(() => {
      this.startClose()
    }, 4000)
  },
  beforeUnmount() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer)
    }
    if (this.closeTimer) {
      clearTimeout(this.closeTimer)
    }
    // body overflow 복구
    document.body.style.overflow = ''
  },
  methods: {
    startClose() {
      if (this.isLeaving) return

      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
      }

      this.isLeaving = true

      // 패널이 다 올라간 후 완전히 숨김
      this.closeTimer = setTimeout(() => {
        document.body.style.overflow = ''
        this.$emit('close')
      }, 1800)
    }
  }
}
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
}

/* 3분할 패널 - 불투명 버건디 그라데이션 */
.split-panel {
  position: absolute;
  top: 0;
  width: 33.34%;
  height: 100%;
  z-index: 2;
  transition: transform 1.2s cubic-bezier(0.76, 0, 0.24, 1);
}

.panel-left {
  left: 0;
}

.panel-center {
  left: 33.33%;
  transition-delay: 0.1s;
}

.panel-right {
  left: 66.66%;
  transition-delay: 0.2s;
}

.panel-left,
.panel-center,
.panel-right {
  background: var(--rayone-primary);
}

.split-panel.slide-up {
  transform: translateY(-100%);
}

/* 워터마크 */
.splash-watermark {
  position: absolute;
  right: -5%;
  bottom: -10%;
  height: 70vh;
  opacity: 0;
  filter: brightness(0) invert(1);
  pointer-events: none;
  z-index: 3;
  animation: watermarkIn 1.5s ease-out 0.3s forwards;
}

.splash-screen.is-leaving .splash-watermark {
  opacity: 0 !important;
  transition: opacity 0.3s ease;
}

@keyframes watermarkIn {
  0% { opacity: 0; transform: scale(0.95); }
  100% { opacity: 0.03; transform: scale(1); }
}

/* 장식 라인 */
.deco-lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  pointer-events: none;
}

.deco-line {
  position: absolute;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--rayone-primary), transparent);
  opacity: 0;
}

.line-top {
  top: 20%;
  left: 10%;
  width: 0;
  animation: lineExpand 1s ease-out 0.8s forwards;
}

.line-bottom {
  bottom: 20%;
  right: 10%;
  width: 0;
  animation: lineExpand 1s ease-out 1s forwards;
}

@keyframes lineExpand {
  0% { width: 0; opacity: 0; }
  50% { opacity: 0.5; }
  100% { width: 180px; opacity: 0.3; }
}

.splash-screen.is-leaving .deco-lines {
  opacity: 0;
  transition: opacity 0.3s ease;
}

/* 콘텐츠 */
.splash-content {
  position: relative;
  z-index: 10;
  text-align: center;
  opacity: 1;
  transition: opacity 0.6s ease;
}

.splash-content.fade-out {
  opacity: 0;
}

/* 서브 타이틀 */
.sub-title {
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 4px;
  margin-bottom: 24px;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeUp 0.8s ease-out 0.3s forwards;
}

/* 메인 타이틀 */
.main-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 40px;
}

.title-brand {
  font-family: var(--font-pretendard);
  font-size: 64px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 12px;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeUp 1s cubic-bezier(0.16, 1, 0.3, 1) 0.6s forwards;
}

.title-central {
  font-family: var(--font-pretendard);
  font-size: 42px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 16px;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeUp 1s cubic-bezier(0.16, 1, 0.3, 1) 0.8s forwards;
}

/* 구분선 */
.divider {
  width: 60px;
  height: 1px;
  background: var(--rayone-primary);
  margin: 0 auto 32px;
  opacity: 0;
  animation: dividerExpand 0.8s ease-out 1.2s forwards;
}

@keyframes dividerExpand {
  0% { width: 0; opacity: 0; }
  100% { width: 60px; opacity: 1; }
}

/* 슬로건 */
.slogan {
  font-family: var(--font-paperlogy);
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 6px;
  opacity: 0;
  animation: fadeUp 0.8s ease-out 1.5s forwards;
}

/* 프로그레스 */
.progress-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: opacity 0.3s ease;
}

.progress-container.fade-out {
  opacity: 0;
}

.progress-bar {
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--rayone-primary-dark), var(--rayone-primary), var(--rayone-primary-light));
  animation: progressFill 4s linear forwards;
}

@keyframes progressFill {
  0% { width: 0%; }
  100% { width: 100%; }
}

@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
